"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImpactRange = void 0;
var getImpactRange = function (impactCounts) {
    var array = cleanData(impactCounts);
    if (isInsufficientData(array))
        return adjustedRange(array);
    return getRangeArray(array);
};
exports.getImpactRange = getImpactRange;
var removeZeros = function (impactCounts) {
    return impactCounts.filter(function (e) { return e > 0; });
};
var isInsufficientData = function (array) {
    return (isEmpty(array)
        ||
            firstElementEqualsLast(array)
        ||
            hasOneElement(array));
};
var isEmpty = function (array) {
    return array.length === 0;
};
var hasOneElement = function (array) {
    return array.length === 1;
};
var firstElementEqualsLast = function (array) {
    return array[0] === array[array.length - 1];
};
var adjustedRange = function (array, adjustment) {
    if (adjustment === void 0) { adjustment = 1; }
    var lastElementIndex = array.length - 1;
    if (array.length === 0)
        return [1, 2];
    if (array.length > 1)
        array[lastElementIndex] += adjustment;
    else if (array.length === 1)
        array.push(array[0] + adjustment);
    return getRangeArray(array);
};
var cleanData = function (impactCounts) {
    var result = removeZeros(impactCounts);
    result.sort(function (a, b) { return a - b; });
    return result;
};
var getRangeArray = function (array) {
    var firstElement = array[0];
    var lastElement = array[array.length - 1];
    return [firstElement, lastElement];
};
